import React from 'react';
import { connect } from 'react-redux';
import { Alert, Label } from 'react-bootstrap';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import List from 'components/List';

import Loader from 'components/layout/Loader';

class ImageClarifaiTags extends React.Component {
  render() {
    const { intl, show, close, image, itemId, tags } = this.props;
    const messages = intl.messages;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.image_recognition_tags}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {show ? (
            <List
              noRender
              listName="recognitionTags"
              url={'/api/items/' + itemId + '/assets/' + image.id + '/recognitionTags.json'}
              list={tags}
            />
          ) : null}

          {tags.pending ? (
            <Loader />
          ) : (
            <div>
              {!tags.data.count ? (
                <Alert bsStyle="info">No tags found</Alert>
              ) : (
                <div class="clearfix">
                  {tags.data.list.map((tag, i) => {
                    return (
                      <div class="pull-left m-r-10 m-b-10" key={i}>
                        <Label>
                          {tag.name} ({tag.probability}%)
                        </Label>{' '}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    tags: state.list.recognitionTags,
  };
};

export default injectIntl(connect(mapStateToProps)(ImageClarifaiTags));
